export const GRAPHQL_URL = `${process.env.REACT_APP_GRAPHQL_URL}`;
export const APP_URL = `${process.env.REACT_APP_URL}`;
